export const changeTime = (time) => {
  // Parse the UTC timestamp to a JavaScript Date object
  const utcDate = new Date(time);

  // Set the timezone to Nepal Standard Time (NST), which is UTC+5:45
  utcDate.setMinutes(utcDate.getMinutes()); // 345 minutes = 5 hours and 45 minutes

  const currentDate = new Date();
  currentDate.setMinutes(currentDate.getMinutes() + 345);

  if (
    utcDate.getDate() === currentDate.getDate() &&
    utcDate.getMonth() === currentDate.getMonth() &&
    utcDate.getFullYear() === currentDate.getFullYear()
  ) {
    const options = {
      hour: "2-digit",
      minute: "2-digit",
    };
    return utcDate.toLocaleString("en-US", options);
  } else {
    const options = {
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    };
    const dateStr = utcDate.toLocaleString("en-US", options);

    return dateStr.replace(
      /\b(\d{1,2})(st|nd|rd|th)\b/,
      (match, day, suffix) => `${day}${suffix}`
    );
  }
};
export const changeTimeSideBar = (time) => {
  // Parse the UTC timestamp to a JavaScript Date object
  const utcDate = new Date(time);

  // Set the timezone to Nepal Standard Time (NST), which is UTC+5:45
  utcDate.setMinutes(utcDate.getMinutes()); // 345 minutes = 5 hours and 45 minutes

  const currentDate = new Date();
  currentDate.setMinutes(currentDate.getMinutes() + 345);

  if (
    utcDate.getDate() === currentDate.getDate() &&
    utcDate.getMonth() === currentDate.getMonth() &&
    utcDate.getFullYear() === currentDate.getFullYear()
  ) {
    const options = {
      hour: "2-digit",
      minute: "2-digit",
    };
    return utcDate.toLocaleString("en-US", options);
  } else {
    const options = {
      day: "numeric",
      month: "short",
    };
    const dateStr = utcDate.toLocaleString("en-US", options);

    return dateStr.replace(
      /\b(\d{1,2})(st|nd|rd|th)\b/,
      (match, day, suffix) => `${day}${suffix}`
    );
  }
};
